








































import Component, { mixins } from "vue-class-component";
import { Route } from "vue-router";
import { Watch } from "vue-property-decorator";
import { InputUsersSearch, UsersSearchResult } from "@teacherskaya/api-provider/dist/api/UserProvider";
import { TagInfo } from "@teacherskaya/api-provider/dist/api/TagsProvider";
import { User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import { Dictionary } from "@teacherskaya/api-provider/dist/api/types";
import WithLoadingStatus from "@/mixins/WithLoadingStatus";
import WithFirstLoad from "@/mixins/WithFirstLoad";
import WithUser from "@/mixins/WithUser";
import WithTags from "@/mixins/WithTags";
import { WatchRoute } from "@/lib/helpers/customDecorators";
import providers from "@/lib/providers";
import config from "@/config";
import BasePageOneColumn from "@/components/BasePageOneColumn.vue";
import GoBack from "@/components/GoBack.vue";
import PageTitle from "@/components/PageTitle.vue";
import PageSubTitle from "@/components/PageSubTitle.vue";
import ModalContainer from "@/components/ModalContainer.vue";
import UserListFilter from "./components/UserListFilter";
import UserListTable from "./components/UserListTable.vue";
import UserListPager from "./components/UserListPager.vue";
import UserListExport from "./components/UserListExport";
import StatUsersString from "./components/UserListStats.vue";
import BlockAddUser from "./components/BlockAddUser/index.vue";

@WatchRoute("submitSearch")
@Component({
  name: "PageUserList",
  components: {
    BasePageOneColumn,
    StatUsersString,
    PageSubTitle,
    PageTitle,
    UserListPager,
    UserListTable,
    GoBack,
    ModalContainer,
    BlockAddUser,
    UserListFilter,
    UserListExport,
  },
})
export default class PageUserList extends mixins(WithUser, WithTags, WithFirstLoad, WithLoadingStatus) {
  public isLoading: boolean = true;

  public balance: Dictionary<number> = {};

  public get userData() {
    return (this.searchResult && this.searchResult.result) || [];
  }

  public get totalPages() {
    return (this.searchResult && this.searchResult.totalPages) || 0;
  }

  get tags(): TagInfo[] {
    return this.state.tags.filter(tag => tag.id === this.tagId);
  }

  public searchResult: UsersSearchResult | null = null;

  public showAddUser: boolean = false;

  public searchRequestData: InputUsersSearch | null = null;

  public get tagId(): string | null {
    const tag = this.$route.query.tag;
    if (typeof tag === "string") {
      return tag;
    }
    if (Array.isArray(tag)) {
      return tag[0];
    }

    return null;
  }

  public get canExportUserList(): boolean {
    return config.featureUserListExport;
  }

  public createHandler({ id }: User): void {
    this.$router.push({
      name: "profile",
      params: { userId: id.toString() },
    });
  }

  public onTagCloseClick() {
    this.$router.push({ query: { tag: undefined } });
  }

  public getSearchRequestData(route: Route): InputUsersSearch {
    const query = route.query;
    return {
      term: query.term ? query.term.toString() : undefined,
      page: !isNaN(Number(query.page)) ? Number(query.page) : undefined,
      role: query.role ? query.role.toString() : undefined,
      size: query.size ? query.size.toString() : undefined,
      tags: query.tag ? [Number(query.tag)] : undefined,
      sort: query.sort ? query.sort.toString() : "REGISTRATION_TIME,DESC",
    };
  }

  public async getUsersData(data: InputUsersSearch) {
    const result = await this.usersSearch({ data });
    if (result.result.length > 0) {
      // this.balance = await providers.TransactionProvider.getBalance({ userIds: result.result.map(user => user.id) });
    }
    this.searchResult = result;
    this.setFirstLoad();
  }

  public getData(data: InputUsersSearch) {
    this.loadingStatusShow([this.getUsersData(data)]).finally(() => {
      this.isLoading = false;
    });
  }

  @Watch("tagId", { immediate: true })
  public getTagsData() {
    if (this.tagId) {
      this.loadingStatusShow([this.tagsGet()]).then(() => {
        this.isLoading = false;
      });
    }
  }

  public submitSearch(route: Route) {
    this.searchRequestData = this.getSearchRequestData(route);
    this.getData(this.searchRequestData);
  }
}
